/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ActiveMenuItem,
    ActiveMenuItemFromJSON,
    ActiveMenuItemFromJSONTyped,
    ActiveMenuItemToJSON,
    DisplayPrice,
    DisplayPriceFromJSON,
    DisplayPriceFromJSONTyped,
    DisplayPriceToJSON,
} from './';

/**
 * 
 * @export
 * @interface OutBopUpdate
 */
export interface OutBopUpdate {
    /**
     * 
     * @type {string}
     * @memberof OutBopUpdate
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OutBopUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OutBopUpdate
     */
    shortText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OutBopUpdate
     */
    information?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OutBopUpdate
     */
    selected: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OutBopUpdate
     */
    disabled: boolean;
    /**
     * 
     * @type {DisplayPrice}
     * @memberof OutBopUpdate
     */
    price?: DisplayPrice;
    /**
     * 
     * @type {string}
     * @memberof OutBopUpdate
     */
    icon?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OutBopUpdate
     */
    movie?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OutBopUpdate
     */
    image?: string | null;
    /**
     * 
     * @type {Array<ActiveMenuItem>}
     * @memberof OutBopUpdate
     */
    activeMenuItems?: Array<ActiveMenuItem> | null;
    /**
     * 
     * @type {string}
     * @memberof OutBopUpdate
     */
    articleNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OutBopUpdate
     */
    productId?: number | null;
}

export function OutBopUpdateFromJSON(json: any): OutBopUpdate {
    return OutBopUpdateFromJSONTyped(json, false);
}

export function OutBopUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutBopUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'shortText': !exists(json, 'shortText') ? undefined : json['shortText'],
        'information': !exists(json, 'information') ? undefined : json['information'],
        'selected': json['selected'],
        'disabled': json['disabled'],
        'price': !exists(json, 'price') ? undefined : DisplayPriceFromJSON(json['price']),
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'movie': !exists(json, 'movie') ? undefined : json['movie'],
        'image': !exists(json, 'image') ? undefined : json['image'],
        'activeMenuItems': !exists(json, 'activeMenuItems') ? undefined : (json['activeMenuItems'] === null ? null : (json['activeMenuItems'] as Array<any>).map(ActiveMenuItemFromJSON)),
        'articleNumber': !exists(json, 'articleNumber') ? undefined : json['articleNumber'],
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
    };
}

export function OutBopUpdateToJSON(value?: OutBopUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'shortText': value.shortText,
        'information': value.information,
        'selected': value.selected,
        'disabled': value.disabled,
        'price': DisplayPriceToJSON(value.price),
        'icon': value.icon,
        'movie': value.movie,
        'image': value.image,
        'activeMenuItems': value.activeMenuItems === undefined ? undefined : (value.activeMenuItems === null ? null : (value.activeMenuItems as Array<any>).map(ActiveMenuItemToJSON)),
        'articleNumber': value.articleNumber,
        'productId': value.productId,
    };
}


